module.exports = __webpack_public_path__ + "static/media/logo-azul.e1815e34.svg";